import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import {
  IFireDispatch,
  IFireDispatchFilters,
} from 'src/models/fire-dispatch.model';
import { IChangeLog } from 'src/models/change-log.model';
import services from 'src/services/fire-dispatch.service';
import emailService from 'src/services/email.service';
import changeLogService from 'src/services/change-log.service';

export const actionTypes = {
  FIRE_DISPATCH_FETCH_DATA: 'FIRE_DISPATCH_FETCH_DATA',
  FIRE_DISPATCH_FETCH_FILTERS: 'FIRE_DISPATCH_FETCH_FILTERS',
  FIRE_DISPATCH_REPORT_DATA: 'FIRE_DISPATCH_REPORT_DATA',
  FIRE_DISPACTH_SEND_EMAIL_REMINDER: 'FIRE_DISPACTH_SEND_EMAIL_REMINDER',
  FIRE_DISPATCH_CHANGE_LOG_FETCH: 'FIRE_DISPATCH_CHANGE_LOG_FETCH',
} as const;

export const asyncActions = {
  listGET: {
    type: actionTypes.FIRE_DISPATCH_FETCH_DATA,
    service: services.listGET,
  },
  reportListGET: {
    type: actionTypes.FIRE_DISPATCH_REPORT_DATA,
    service: services.reportListGET,
  },
  filterGET: {
    type: actionTypes.FIRE_DISPATCH_FETCH_FILTERS,
    service: services.filterGET,
  },
  sendEmailNotificationPOST: {
    type: actionTypes.FIRE_DISPACTH_SEND_EMAIL_REMINDER,
    service: emailService.sendEmailNotificationPOST,
  },
  changeLogGET: {
    type: actionTypes.FIRE_DISPATCH_CHANGE_LOG_FETCH,
    service: changeLogService.changeLogGET,
  },
};

export type IFireDispatchAsync = typeof asyncActions;

export interface IFireDispatchState extends ICommonState<IFireDispatchAsync> {
  data?: IFireDispatch;
  list: IFireDispatch[];
  filters: IFireDispatchFilters;
  changeLog: IChangeLog[];
  total: number;
  logTotal: number;
  cancelled: number;
  completed: number;
  dispatched: number;
  inFlight: number;
  landed: number;
}

export const defaultState: IFireDispatchState = {
  status: {},
  list: [],
  changeLog: [],
  total: 0,
  logTotal: 0,
  filters: {},
  cancelled: 0,
  completed: 0,
  dispatched: 0,
  inFlight: 0,
  landed: 0,
};

const FireDispatchReducer = (
  state: IFireDispatchState = defaultState,
  action: IReducerAction<IFireDispatchAsync>
): IFireDispatchState => {
  switch (action.type) {
    case actionTypes.FIRE_DISPATCH_FETCH_FILTERS: {
      return {
        ...state,
        filters: action.payload ?? {},
      };
    }

    case actionTypes.FIRE_DISPATCH_FETCH_DATA: {
      return {
        ...state,
        list: action.payload?.fireDispatch.rows ?? [],
        total: action.payload?.fireDispatch.counts?.all ?? 0,
        cancelled: action.payload?.fireDispatch.counts?.cancelled ?? 0,
        completed: action.payload?.fireDispatch.counts?.completed ?? 0,
        dispatched: action.payload?.fireDispatch.counts?.dispatched ?? 0,
        inFlight: action.payload?.fireDispatch.counts?.inFlight ?? 0,
        landed: action.payload?.fireDispatch.counts?.landed ?? 0,
      };
    }

    case actionTypes.FIRE_DISPATCH_CHANGE_LOG_FETCH: {
      return {
        ...state,
        changeLog: action.payload?.changelog.rows ?? [],
        logTotal: action.payload?.changelog.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default FireDispatchReducer;
